module.exports = __webpack_public_path__ + "img/heart.0984040e.svg";